import L from "leaflet";
import { Marker } from "react-leaflet";
import { VehicleGeolocated } from "./index";
import { useMemo, useCallback } from "react";
import vehicleDotIconUrl from "@qivia/ui/src/assets/vehicleDot.svg";
import { getDataPointsByVehicleAndDateAsync } from "./geolocationSlice";
import { useAppDispatch } from "../../../redux/hooks";
import { TooltipVehicleTrip } from "./tooltipVehicleTrip";

export const VehiclesShowOnMap = (props: {
  handleSelectVehicle: (vehicle: VehicleGeolocated) => void;
  hoveredVehicleId: string | null;
  setShowTripForVehicleUuid: (vehicleUuid: string) => void;
  showTripForVehicleUuid: string | null;
  vehiclesToDisplay: VehicleGeolocated[];
  date: Date;
}) => {
  const dispatch = useAppDispatch();
  const {
    handleSelectVehicle,
    hoveredVehicleId,
    setShowTripForVehicleUuid,
    showTripForVehicleUuid,
    vehiclesToDisplay,
    date,
  } = props;

  const vehiclesToShowOnMap = useMemo(
    () =>
      vehiclesToDisplay.filter((v) => {
        if (
          v.uuid === showTripForVehicleUuid &&
          v.dataPoints &&
          v.dataPoints.length > 0
        )
          return false;
        if (hoveredVehicleId && v.uuid !== hoveredVehicleId) return false;
        return true;
      }),
    [hoveredVehicleId, showTripForVehicleUuid, vehiclesToDisplay],
  );

  const onClickVehicleOnMap = useCallback(
    (vehicle: VehicleGeolocated) => {
      handleSelectVehicle(vehicle);
      if (!vehicle.dataPoints) {
        void dispatch(
          getDataPointsByVehicleAndDateAsync({
            vehicleUuid: vehicle.uuid,
            date: date.toISOString(),
          }),
        );
      }
      setShowTripForVehicleUuid(vehicle.uuid);
    },
    [date, dispatch, handleSelectVehicle, setShowTripForVehicleUuid],
  );

  return (
    <>
      {vehiclesToShowOnMap.map((v) => (
        <Marker
          position={[v.lastLatitude || 0, v.lastLongitude || 0]}
          key={v.uuid}
          icon={vehicleOnIcon}
          eventHandlers={{
            click: () => onClickVehicleOnMap(v),
          }}
        >
          <TooltipVehicleTrip
            vehicle={v}
            handleSelectVehicle={handleSelectVehicle}
          />
        </Marker>
      ))}
    </>
  );
};

const vehicleOnIcon = L.icon({
  iconUrl: vehicleDotIconUrl,
  iconSize: [24, 24],
  iconAnchor: [12, 16],
});
